import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  CircularProgress,
  Alert,
} from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const SubscriptionSuccess = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Give some time for Stripe's webhook to process the subscription
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);
    
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <Container maxWidth="md">
      <Box sx={{ my: 8 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          {loading ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <CircularProgress size={60} sx={{ mb: 3 }} />
              <Typography variant="h5" gutterBottom>
                Processing your subscription...
              </Typography>
              <Typography variant="body1" color="text.secondary">
                Please wait while we finalize your subscription.
              </Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <CheckCircle color="success" sx={{ fontSize: 60, mb: 3 }} />
              <Typography variant="h4" gutterBottom>
                Subscription Successful!
              </Typography>
              <Typography variant="body1" paragraph>
                Thank you for subscribing to SetSync. Your venue now has access to premium audio streaming capabilities.
              </Typography>
              <Typography variant="body2" color="text.secondary" paragraph>
                Your subscription details are available in your dashboard.
              </Typography>
              
              {error && (
                <Alert severity="warning" sx={{ mt: 2, mb: 4, width: '100%' }}>
                  {error}
                </Alert>
              )}
              
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate('/venue/dashboard')}
                sx={{ mt: 3 }}
              >
                Go to Dashboard
              </Button>
            </Box>
          )}
        </Paper>
      </Box>
    </Container>
  );
};

export default SubscriptionSuccess; 